export { AtnDsNumberComponent as Component } from './number.component'
export * as models from './models'
